var _defs, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIkonerOppgaverUtdanningsvalgLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#333;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Ikoner") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M104.74,102.44H82.58a1,1,0,0,1,0-2h21.16V51.55a1,1,0,1,1,2,0v49.9A1,1,0,0,1,104.74,102.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M104.74,31a1,1,0,0,1-1-1V27.4H89.62a1,1,0,1,1,0-2h15.12a1,1,0,0,1,1,1V30A1,1,0,0,1,104.74,31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.68,102.44H28a1,1,0,0,1-1-1V90.78a1,1,0,0,1,2,0v9.68H59.68a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M80.25,109.37a1.13,1.13,0,0,1-.32-.05L7.21,84.83a1,1,0,0,1-.62-1.26L31.08,10.86a1,1,0,0,1,1.26-.63l72.71,24.49a1,1,0,0,1,.63,1.26L81.19,108.7a1.07,1.07,0,0,1-.5.57A1,1,0,0,1,80.25,109.37ZM8.79,83.26l70.83,23.86,23.86-70.83L32.65,12.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.1,47.11a8.61,8.61,0,0,1-8.61-8.6V29.77a1,1,0,0,1,2,0v8.74a6.62,6.62,0,1,0,13.23,0V21A6.62,6.62,0,0,0,59,18.58a1,1,0,0,1-1.29.55,1,1,0,0,1-.55-1.29A8.6,8.6,0,0,1,73.7,21V38.51A8.61,8.61,0,0,1,65.1,47.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.1,41.39a2.88,2.88,0,0,1-2.89-2.88V29.77a1,1,0,1,1,2,0v8.74a.91.91,0,0,0,.91.9,1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.82,74.07a1.19,1.19,0,0,1-.32,0L38.86,64.71a1,1,0,0,1-.63-1.26,1,1,0,0,1,1.26-.62l27.65,9.31a1,1,0,0,1-.32,1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.2,63.37a1.12,1.12,0,0,1-.31,0L42.24,54a1,1,0,0,1,.63-1.88l27.65,9.32a1,1,0,0,1-.32,1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.73,85.16a.93.93,0,0,1-.32,0L34.77,75.8a1,1,0,0,1-.63-1.26,1,1,0,0,1,1.26-.62l27.65,9.31a1,1,0,0,1-.32,1.93Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIkonerOppgaverUtdanningsvalgLarge);
export default __webpack_public_path__ + "static/media/Ikoner_Oppgaver-utdanningsvalg_large.93b734d60329e801e256aced5ceda461.svg";
export { ForwardRef as ReactComponent };